import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
    },
  },
  leftSection: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    gap: '12px',
    [theme.breakpoints.down('sm')]: { gap: '10px' },
  },
  backButton: {
    height: '32px',
    width: '32px',
    padding: '4px',
    borderRadius: '4px',
    border: '1px solid rgba(233, 235, 245, 1)',
    background: 'rgba(250, 250, 254, 1)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '10px',
    cursor: 'pointer',
    [theme.breakpoints.down('sm')]: {
      height: '28px',
      width: '28px',
      padding: '3px',
    },
  },
  title: {
    fontSize: '24px',
    fontWeight: 500,
    fontStyle: 'normal',
    [theme.breakpoints.down('md')]: { fontSize: '22px' },
    [theme.breakpoints.down('sm')]: { fontSize: '20px' },
  },
  customChip: {
    borderRadius: '100px',
    color: 'rgba(46, 125, 50, 1)',
    border: '1px solid rgba(46, 125, 50, 1)',
  },

  /* Tabs */
  tabsRow: {
    display: 'flex',
    justifyContent: 'start',
    alignItems: 'center',
    borderBottom: '1px solid rgba(198, 199, 209, 1)',
    gap: '15px',
    [theme.breakpoints.down('sm')]: { gap: '12px' },
  },
  tab: {
    display: 'flex',
    gap: '12px',
    padding: '6px',
    cursor: 'pointer',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      gap: '10px',
      padding: '5px',
    },
  },
  tabActiveBorder: {
    borderBottom: '1px solid rgba(63, 81, 181, 1)',
    marginBottom: '-1px',
  },
  tabInactiveBorder: {
    borderBottom: '1px solid transparent',
    marginBottom: 0,
  },
  tabImage: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  icon16: {
    height: 16,
    width: 16,
  },
  tabText: {
    fontSize: '14px',
    fontWeight: 400,
    fontStyle: 'normal',
    [theme.breakpoints.down('sm')]: { fontSize: '13px' },
  },
  tabTextActive: {
    color: 'rgba(63, 81, 181, 1)',
  },
  tabTextInactive: {
    color: 'rgba(120, 121, 142, 1)',
  },
}));

const TopHeaderViewer = (props) => {
    const { data, formData, setActiveTabMain, activeTabMain, blockState } = props;
    const { chartData, chartUniqueId } = data || {};
    const classes = useStyles();

    const chatRedirect = () => {
        props.history.push({
            pathname: `/${props?.match?.params?.appid}/page/${chartData.listPages}`
        });
    };

    return (
        <React.Fragment>
            <div className={classes.container}>
                <div className={classes.headerRow}>
                    <div className={classes.leftSection}>
                        <div className={classes.backButton} onClick={() => { chatRedirect() }}>
                            <img src={'/media/svg/previousIconObligations.svg'} alt="back" />
                        </div>
                        <Typography color="textPrimary" className={classes.title}>
                            Opportunity Tracker
                        </Typography>
                    </div>

                    <div>
                        <Chip
                            label={blockState["documentStatus"]}
                            variant="outlined"
                            classes={{ outlined: classes.customChip }}
                        />
                    </div>
                </div>
            </div>

            {/* Tabs */}
            <div className={classes.tabsRow}>
                <div
                    className={classes.tab}
                    style={{
                        borderBottom:
                            activeTabMain === "clause"
                                ? '1px solid rgba(63, 81, 181, 1)'
                                : '1px solid transparent',
                        marginBottom: activeTabMain === "clause" ? '-1px' : '0px',
                    }}
                    onClick={() => setActiveTabMain("clause")}
                >
                    <div className={classes.tabImage}>
                        {activeTabMain === "audit" && <img src={'/media/svg/crown.svg'} alt="crown" style={{height:'16px', width:'16px'}}/>}
                        {activeTabMain === "clause" && <img src={'/media/svg/crownBlue.svg'} alt="crownBlue" style={{height:'16px', width:'16px'}}/>}
                    </div>
                    <Typography
                        className={classes.tabText}
                        style={{
                            color:
                                activeTabMain === "clause"
                                    ? 'rgba(63, 81, 181, 1)'
                                    : 'rgba(120, 121, 142, 1)',
                        }}
                    >
                        Opportunity Details
                    </Typography>
                </div>

                <div
                    className={classes.tab}
                    style={{
                        borderBottom:
                            activeTabMain === "audit"
                                ? '1px solid rgba(63, 81, 181, 1)'
                                : '1px solid transparent',
                        marginBottom: activeTabMain === "audit" ? '-1px' : '0px',
                    }}
                    onClick={() => setActiveTabMain("audit")}
                >
                    <div className={classes.tabImage}>
                        {activeTabMain === "clause" && <img src={'/media/svg/AuditTrail.svg'} alt="crown" style={{height:'16px', width:'16px'}}/>}
                        {activeTabMain === "audit" && <img src={'/media/svg/AuditTrailBlue.svg'} alt="crownBlue" style={{height:'16px', width:'16px'}}/>}
                    </div>
                    <Typography
                        className={classes.tabText}
                        style={{
                            color:
                                activeTabMain === "audit"
                                    ? 'rgba(63, 81, 181, 1)'
                                    : 'rgba(120, 121, 142, 1)',
                        }}
                    >
                        Audit Trails
                    </Typography>
                </div>
            </div>
        </React.Fragment>
    );
};

export default TopHeaderViewer;
